import {useEffect} from "react";
import {usePeriod} from '../../contexts/period'
import {useAuth} from "../../contexts/auth";
import {getCurrentPeriod} from "../../api/dogovor";
import {getFirstDayOfMounth} from "../../utils/date.utils";

export const calendarOptions = {
    applyValueMode: "useButtons",
    showDropDownButton: true,
    maxZoomLevel: 'year',
    minZoomLevel: 'century'
}

export function addMonths(date, months) {
    const newDate = new Date(date);
    newDate.setMonth(newDate.getMonth() + months);
    return newDate;
}

/** Инициализация periodStart/periodEnd по текущему периоду договора */
export function useInitPeriod(enabled = true) {
    const { setPeriodStart, setPeriodEnd } = usePeriod()
    const { selectedDog } = useAuth()

    useEffect(() => {
        if (!enabled || !selectedDog?.kodDog) return
        (async function () {
            const periodRes = await getCurrentPeriod(selectedDog.kodDog)
            if (periodRes.isOk) {
                const startPeriod = getFirstDayOfMounth(new Date(periodRes.data.period))
                setPeriodStart(addMonths(startPeriod, -2))
                setPeriodEnd(addMonths(startPeriod, 2))
            }
        })()
    }, [enabled, selectedDog, setPeriodStart, setPeriodEnd])
}
